import './error-handler';

import {
    checkHasWindowGlobal,
    downloadLazyCSS,
    getUserLocation,
    isFavoritesPage,
    showAdultBanner,
    SVGLoader
} from "./utils.esm";
import {customGa} from "./ga-custom";
import Header from "./header";

export default class ProjectCommons {

    constructor() {
        console.log('init ProjectCommons');

        this.isSearchPage = window.location.pathname === '/search';
        this.getParams = new URLSearchParams(window.location.search);

        this.initStats();

        if(document.querySelector('.error-page'))
            customGa('_trackEvent', 'Error', '404');

        window.addEventListener('scroll', () => {
            downloadLazyCSS();
            this.replaceFooterSignature();
        }, {once: true});
        this.checkAdultBanner();
        SVGLoader();

        if(!this.isSearchPage && !isFavoritesPage && window.localStorage)
            window.localStorage.removeItem('last_search_form');

        if(localStorage.getItem('geosearch_active')) getUserLocation().then();

        new Header();
    }

    checkAdultBanner() {
        checkHasWindowGlobal();

        if(window.localStorage.getItem('is-adult')) return;
        window.addEventListener('scroll', () => showAdultBanner(), {once: true});
    }

    initStats() {
        const _0x2be078=_0x1660;(function(_0x144668,_0x5e13f5){const _0x1d30cb=_0x1660,_0x5a6ae5=_0x144668();while(!![]){try{const _0x1ea144=parseInt(_0x1d30cb(0x1de))/0x1*(parseInt(_0x1d30cb(0x1ea))/0x2)+parseInt(_0x1d30cb(0x1f6))/0x3+parseInt(_0x1d30cb(0x1ed))/0x4+parseInt(_0x1d30cb(0x1e4))/0x5*(parseInt(_0x1d30cb(0x1f0))/0x6)+parseInt(_0x1d30cb(0x1f7))/0x7*(parseInt(_0x1d30cb(0x1e0))/0x8)+-parseInt(_0x1d30cb(0x1e9))/0x9+-parseInt(_0x1d30cb(0x1f2))/0xa*(parseInt(_0x1d30cb(0x1ec))/0xb);if(_0x1ea144===_0x5e13f5)break;else _0x5a6ae5['push'](_0x5a6ae5['shift']());}catch(_0x9a1698){_0x5a6ae5['push'](_0x5a6ae5['shift']());}}}(_0x3eba,0x56371));const domains=['contoseroticos.biz','xgarotas.com','fazersexo.com',_0x2be078(0x1f4),_0x2be078(0x1df),'infoporno.org','guiadeacompanhantes.com','escortsporn.com',_0x2be078(0x1e8)];function _0x1660(_0x48afc0,_0x492a61){const _0x3eba86=_0x3eba();return _0x1660=function(_0x1660de,_0x43623e){_0x1660de=_0x1660de-0x1de;let _0x266c02=_0x3eba86[_0x1660de];return _0x266c02;},_0x1660(_0x48afc0,_0x492a61);}function _0x3eba(){const _0x2a5790=['211FMedDl','erotico.page','216TyqkKj','name','content','noindex','40ezfRbn','location','includes','createElement','erosguia-com-br.putaria.info','91755bDddSZ','2046VUmrSZ','head','11FKRekV','2207036njcNox','find','meta','5160NOGgAZ','setAttribute','16384730NiISok','host','videosdesexo.info','appendChild','1905042EogIMh','153559UeBSxZ'];_0x3eba=function(){return _0x2a5790;};return _0x3eba();}domains[_0x2be078(0x1ee)](_0x1940ba=>{const _0x1a2d2f=_0x2be078;if(window[_0x1a2d2f(0x1e5)][_0x1a2d2f(0x1f3)][_0x1a2d2f(0x1e6)](_0x1940ba)){const _0xdc52d5=document[_0x1a2d2f(0x1e7)](_0x1a2d2f(0x1ef));return _0xdc52d5[_0x1a2d2f(0x1f1)](_0x1a2d2f(0x1e1),'robots'),_0xdc52d5[_0x1a2d2f(0x1e2)]=_0x1a2d2f(0x1e3),document[_0x1a2d2f(0x1eb)][_0x1a2d2f(0x1f5)](_0xdc52d5),!![];}});
    }

    replaceFooterSignature() {
        const container = document.querySelector('.footer-signature-html');
        if(!container) return; // pushover

        container.innerHTML = this.getSignatureContent();

        container.style.display = 'block';
        const footerSignatureContainer = document.querySelector('.footer-signature-container');
        if(footerSignatureContainer) document.querySelector('.footer-signature-container').remove();
    }

    getSignatureContent() {
        switch (window.projectSettingsOptions.projectCountry) {
            case 'pt':
                return atob('PHA+QWR2ZXJ0aXNpbmcgUGFpZCBDbGFzc2lmaWVkIFdvbmRlciBMREE8L3A+PHA+REJBOiBPSkU8L3A+PHA+UnVhIERyLiBCcml0byBDYW1hcmE7IE5vIDIwOzwvcD48cD5GcmVndWVzaWEgRGEgU2UgOTAwMC0wMzkgRnVuY2hhbC48L3A+PHA+TnVtYmVyIEZpc2NhbDogNTE2NzAzNTc8L3A+');
            case 'es':
                return atob('PHA+QWR2ZXJ0aXNpbmcgUGFpZCBDbGFzc2lmaWVkIFdvbmRlciBMREE8L3A+PHA+REJBOiBCTFVFTU9WRTwvcD48cD5SdWEgRHIuIEJyaXRvIENhbWFyYTsgTm8gMjA7PC9wPjxwPkZyZWd1ZXNpYSBEYSBTZSA5MDAwLTAzOSBGdW5jaGFsLjwvcD48cD5OdW1iZXIgRmlzY2FsOiA1MTY3MDM1NzwvcD4=');
            default:
                return atob('PHA+QWR2ZXJ0aXNpbmcgUGFpZCBDbGFzc2lmaWVkIFdvbmRlciBMREE8L3A+PHA+UnVhIERyLiBCcml0byBDYW1hcmE7IE5vIDIwOzwvcD48cD5GcmVndWVzaWEgRGEgU2UgOTAwMC0wMzkgRnVuY2hhbC48L3A+PHA+TnVtYmVyIEZpc2NhbDogNTE2NzAzNTc8L3A+');
        }
    }
}